import { AsyncPipe, isPlatformBrowser, NgFor } from '@angular/common';
import { Component, inject, Inject, PLATFORM_ID } from '@angular/core';
import { Hero } from '../../components/hero/hero';
import { Product } from '../../components/product/product';
import { FeaturedProducts } from '../../components/featured-products/featured-products';
import { ShopByCategory } from '../../components/shop-by-category/shop-by-category';
import { Reviews } from '../../components/reviews/reviews';
import { Loading } from '../../components/loading/loading';
import { AuthService } from '../../service/auth-service';
import { BehaviorSubject, combineLatest, map, timer } from 'rxjs';
import { ProductService } from '../../service/product-service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [Hero, FeaturedProducts, ShopByCategory, Reviews],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home {
  
}
